import { FC } from 'react';
import styles from './index.module.less';
import { Spin } from 'antd';

/** 骨架屏-详情 */
const SkeletonDetail:FC<{}> = () => {
  return (
    <div className={styles.container}>
      <Spin tip={<div className={styles.loadingText}>详情内容加载中，请稍侯。</div>}>
        {/* title */}
        <div className={styles.titleBox}>
          <div className={`${styles.title} ${styles.common}`}></div>
          <div className={`${styles.btn} ${styles.common}`}></div>
        </div>
        {/* 标签 */}
        <div className={`${styles.tag} ${styles.common}`}></div>
        {/* 内容 */}
        <div className={styles.box}>
          <div className={styles.contextBox}>
            <div className={styles.left}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
            <div className={styles.right}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
          </div>
          <div className={styles.contextBox}>
            <div className={styles.left}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
            <div className={styles.right}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
          </div>
          <div className={styles.contextBox}>
            <div className={styles.left}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
            <div className={styles.right}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
          </div>
        </div>

        {/* 分割线 */}
        <div className={styles.line}></div>
        <div className={styles.tab}>
          <div className={`${styles.title} ${styles.common}`}></div>
          <div className={`${styles.contentOne} ${styles.common}`}></div>
          <div className={`${styles.contentTwo} ${styles.common}`}></div>
          <div className={styles.btnBox}>
            <div></div>
            <div className={`${styles.btn} ${styles.common}`}></div>
          </div>
        </div>
        {/* 分割线 */}
        <div className={styles.line}></div>
        <div className={styles.box}>
          <div className={`${styles.tag} ${styles.common}`}></div>
          <div className={styles.contextBox}>
            <div className={styles.left}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
            <div className={styles.right}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
          </div>
          <div className={styles.contextBox}>
            <div className={styles.left}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
            <div className={styles.right}>
              <div className={`${styles.title} ${styles.common}`}></div>
              <div className={`${styles.context} ${styles.common}`}></div>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default SkeletonDetail;
